import {
  Card,
  CardCaption,
  CardTitle,
  EducationScreen,
  Gold,
  Registered,
  RevealBlock,
  ScreenIntro,
} from './EducationShell';
import {BRANDED_BLOCK_ROWS, BRANDED_TIMELINE_MILESTONES, SleepBlocksHero, TimelineViz} from './Step10Viz';
import {ZepboundDisclaimer} from './ZepboundDisclaimer';
import styles from './Glp1EducationOutcomeBranded.module.css';

/** Step 10 — branded. Outcome envisioning over the first year on Zepbound. */
export const Glp1EducationOutcomeBranded = () => (
  <EducationScreen
    ctaLabel="Next"
    variant="branded_v1"
    analyticsShown="GLP-1 Funnel Education Outcome Viewed"
    analyticsSubmitted="GLP-1 Funnel Education Outcome Continue Tapped"
  >
    <ScreenIntro
      headline={
        <>
          Week by week, <Gold>sleep interruptions</Gold> decrease.
        </>
      }
      subhead={
        <>
          Untreated apnea typically means ~37 breathing events per hour — roughly 300 over a full night.
          <br />
          <span className={styles.citation}>(American Academy of Sleep Medicine)</span>
        </>
      }
    />

    <RevealBlock delayMs={300}>
      <SleepBlocksHero rows={BRANDED_BLOCK_ROWS} delayMs={200} />
    </RevealBlock>

    <RevealBlock delayMs={500}>
      <Card>
        <CardTitle>
          How <Gold>progress</Gold> feels.
        </CardTitle>
        <TimelineViz milestones={BRANDED_TIMELINE_MILESTONES} delayMs={200} />
        <CardCaption>
          Individual results vary; not everyone responds. Milestones shown are illustrative, not guaranteed. Based on
          SURMOUNT-OSA (NEJM, 2024). Your clinician will track your actual progress. See Medication Guide for Zepbound
          <Registered size={9} /> at pi.lilly.com.
        </CardCaption>
      </Card>
    </RevealBlock>

    <RevealBlock delayMs={700}>
      <ZepboundDisclaimer />
    </RevealBlock>
  </EducationScreen>
);

export default Glp1EducationOutcomeBranded;
